<template>
  <v-container fluid class="px-1 py-1">
    <CommonTable
        title="SimpleMainList"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/Common/Example/SimpleMainDetail"
        :parent-component="$options.name"
    >
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import SimpleMainDetail from "@/components/Common/Example/SimpleMainDetail";

export default {
  name: "SimpleMainTable",

  props: {
    embedded: {default: false},
    storeName: {type: [String], default: 'SimpleMainTable'},
    dtoDetailQuery: {default: 'SimpleDetailQueryDTO'},
    detailStoreName: {default: 'SimpleMainDetail'},
    dtoListQuery: {type: [String], default: 'SimpleListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'SimpleActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'SimpleSaveCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    SimpleMainDetail,
  },

  methods: {
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'name', value: 'name', sortable: true, filterable: true, divider: true},
      {text: 'version', value: 'version', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.dtoSaveCommand = this.dtoSaveCommand
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>